import { Component } from '@angular/core';
import { NavController,AlertController,App } from 'ionic-angular';


import { ModifyPasswordPage } from "../password/modifypwd";
import { StorageService } from '../../../providers/service/storageservice';
import { WebService } from '../../../providers/service/webservice';
import { LoginPage } from '../../login/login/login';
import { BindPhonePage } from "../bind/bindphone";
import { PersonalInfo } from '../../application/teaching/personalinfo/personalinfo';
import { AppState } from '../../../app/app.global';
import { SetGesturePage } from '../setgesture/setgesture'

/**
 * Generated class for the AccountPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-account',
  templateUrl: 'account.html',
})
export class AccountPage {

  user:any =null;
	constructor (public navCtrl: NavController,public appCtrl: App,private alertCtrl: AlertController,public global: AppState,private webService:WebService) {
    this.user = StorageService.getObj('currentUser');
    
  }
  
  goToPersonalInfo(){
		if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
      StorageService.remove('currentUser');
      this.appCtrl.getRootNav().push(LoginPage);
    }else{
    	this.appCtrl.getRootNav().push(PersonalInfo);
    }
	} 
  
  modifyPassword(){
    if(this.user&&this.user.userId!=null&&this.user.userId!=''&&this.user.userId!='undefined'){
  		this.appCtrl.getRootNav().push(ModifyPasswordPage,{});
  	}else{
  		this.appCtrl.getRootNav().push(LoginPage);
  	}
  }
  setGesture(){
    if(this.user&&this.user.userId!=null&&this.user.userId!=''&&this.user.userId!='undefined'){
  		this.appCtrl.getRootNav().push(SetGesturePage,{});
  	}else{
  		this.appCtrl.getRootNav().push(LoginPage);
  	}
  }
  bindPhone(){
    if(this.user&&this.user.userId!=null&&this.user.userId!=''&&this.user.userId!='undefined'){
  		this.appCtrl.getRootNav().push(BindPhonePage,{});
  	}else{
  		this.appCtrl.getRootNav().push(LoginPage);
  	}
    
  }
  loginOut(){
		StorageService.remove('currentUser');
		this.appCtrl.getRootNav().push(LoginPage);
	}

}



// WEBPACK FOOTER //
// ./src/pages/about/account/account.ts